export const URLs = {
    TEAMS: 'teams',
    JOBS: 'jobs',
};

export const PAGE_NAME = 'jobs_page';

export const BLOCKED_COUNTRIES = {
    IN: 'India',
    PK: 'Pakistan',
    PH: 'Philippines',
    BD: 'Bangladesh',
    ZA: 'South Africa',
    NG: 'Nigeria',
    LK: 'Sri Lanka',
    ID: 'Indonesia',
    KE: 'Kenya',
    JM: 'Jamaica',
    VN: 'Vietnam',
    EG: 'Egypt',
    MY: 'Malaysia',
    MA: 'Morocco',
    CN: 'China',
    SG: 'Singapore',
    MX: 'Mexico',
    SA: 'Saudi Arabia',
    GH: 'Ghana',
    KR: 'South Korea',
    DZ: 'Algeria',
    AL: 'Albania',
    TH: 'Thailand',
    ZW: 'Zimbabwe',
    VE: 'Venezuela',
    MK: 'North Macedonia',
    NP: 'Nepal',
    AR: 'Argentina',
    TW: 'Taiwan',
    TT: 'Trinidad and Tobago',
    KH: 'Cambodia',
    MU: 'Mauritius',
    HK: 'Hong Kong',
    TN: 'Tunisia',
    JP: 'Japan',
};
